import React from 'react';
import SavingButton from 'library/components/saving-button';

const RealInstructionsModal = ({ onComplete, saving }) => (
    <div className="survey-instructions-inner">
        <div className="survey-instructions-left">
            <h1>INSTRUCTIONS</h1>
            <p>You are about to take The PAIRIN Survey. This survey will calculate your strengths in key professional areas like leadership and teamwork.</p>
            <p>In the first part of the survey, describe yourself with the adjectives shown. Answer honestly, based on how you “usually” act and think, to make sure you get the most accurate results possible. Click the icons to get audio, additional languages, and definitions.</p>
            <blockquote>{"If you can't finish in one sitting, feel free to come back within 24 hours."}</blockquote>
            <SavingButton saving={saving} onClick={()=>onComplete('real')}>Get Started</SavingButton>
        </div>
        <div className="survey-instructions-right">
            <img src="https://assets.pairin.com/production/survey/stack-real.gif" />
        </div>
    </div>
)

export default RealInstructionsModal;
